import { HttpParams } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faSearch, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseModal } from '../../shared'

@Component({
    templateUrl: './meeting-items-selection.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent, WjInputModule],
})
export class MeetingItemsSelectionComponent extends BaseModal implements OnInit {
    faSpinner = faSpinner
    faSearch = faSearch
    search = ''
    itemType = 'Goals'
    meetingId = ''

    allItems: any[] = []
    filteredItems: any[] = []
    itemIds: any[] = []

    ngOnInit(): void {
        this.refreshItems()
    }

    refreshItems() {
        let query
        // TODO: see if we can use ByAction('ForLookup'), but Goals has a sort key of 'order'
        if (this.itemType === 'Goals') query = this.services.data.get('/api/HrGoal/GetForMeetingLookup')
        else if (this.itemType === 'To-Dos')
            query = this.services.data.get('/api/ToDo/GetForMeetingLookup', new HttpParams().set('active', true))
        else if (this.itemType === 'Rocks')
            query = this.services.data.get('/api/Rock/GetForMeetingLookup', new HttpParams().set('active', true))
        console.log('Query:', query)
        this.services.data.load(true, true, query).subscribe({
            next: result => {
                console.log('Result:', result)
                this.allItems = (result[0] as any[]).orderBy(x => x.name)
                this.allItems.forEach(x => {
                    if (this.itemIds.indexOf(x.id) > -1) x['checked'] = true
                    else x['checked'] = false
                })
                this.filteredItems = this.allItems
            },
        })
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        const ids = this.allItems.filter(x => x['checked']).map(x => x.id)
        const params = new HttpParams().set('itemType', this.itemType).set('meetingId', this.meetingId).set('isAdding', true)
        this.services.data.put('/api/Meeting/UpdateItemIds', ids, params).subscribe({
            next: () => {
                resolveSave()
            },
            error: errorResult => {
                rejectSave(errorResult)
            },
        })
    }

    modelChangeFn(value) {
        if (value === '') {
            this.filteredItems = this.allItems
        } else {
            this.filteredItems = this.allItems.filter(x => x.name.toLowerCase().includes(value.toLowerCase()))
        }
    }
}
